export default {
    price: 5000,
    hasCustomBackground: true,
    light: {
        primary: '#29C229',
        secondary: '#B76715',
        accent: '#92EF92',
    },
    dark: {
        primary: '#1C831C',
        secondary: '#72400D',
        accent: '#92EF92',
    }
}
